import React from 'react';
import config from 'Config/config.json';
import get from 'lodash.get';

import { Ad } from 'Components/atoms/Ad';

import { getCustomizedAdConfig } from 'SharedHelpers/getCustomizedAdConfig';

export const getAfterContentAd = ({ afterContentDesktopAds = null, afterContentMobileAds = null }) => {
  const adConfig = get(config, 'ads.slot-1');

  if (adConfig) {
    return (
      <Ad
        extraClassNames={{
          '-full-width': true,
          '-after-content': true,
          'hide-mobile': !afterContentMobileAds,
          'hide-tablet': !afterContentMobileAds,
          'hide-desktop': !afterContentDesktopAds,
        }}
        id="refresh-after_content_1"
        isSkippable
        isSpaceReserved
        key="after_content_1"
        targeting={{
          position: 'after_content_1',
          placement: 'after_content_1',
          refresh: 'yes',
        }}
        {...adConfig}
        {...getCustomizedAdConfig({
          desktopRule: afterContentDesktopAds,
          mobileRule: afterContentMobileAds,
        })}
      />
    );
  }

  return false;
};
